import React from 'react';
import { cn } from '../../../lib/utils';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';
import { Plus, Trash2 } from 'lucide-react';
import { PayersDialogProps } from '../types';

export function PayersDialog({
  isDark,
  isOpen,
  onOpenChange,
  payers,
  newPayerName,
  onNewPayerNameChange,
  onAddPayer,
  onDeletePayer,
}: PayersDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className={cn('max-w-md', isDark ? 'bg-[#1A1A22] border-slate-700' : 'bg-white')}>
        <DialogHeader>
          <DialogTitle className={cn(isDark ? 'text-white' : 'text-[#111111]')}>Плательщики</DialogTitle>
          <DialogDescription className={cn(isDark ? 'text-slate-400' : 'text-slate-500')}>
            Кто оплатил расход: основатель (растёт долг компании перед ним) или
            счёт компании (уменьшается касса)
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="flex items-center gap-2">
            <Input
              value={newPayerName}
              onChange={(e) => onNewPayerNameChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onAddPayer();
              }}
              placeholder="Имя плательщика"
              className={cn(isDark ? 'bg-slate-800 border-slate-700 text-white' : 'bg-white border-slate-200')}
            />
            <Button onClick={onAddPayer} className="bg-[#C9A227] hover:bg-[#C9A227]/90 shrink-0">
              <Plus className="w-4 h-4" />
            </Button>
          </div>

          <div className="space-y-2 max-h-72 overflow-y-auto">
            {payers.length === 0 ? (
              <p className="text-sm text-center text-slate-500 py-4">Пока нет плательщиков</p>
            ) : (
              payers.map((payer) => (
                <div
                  key={payer.id}
                  className={cn(
                    'flex items-center justify-between rounded-lg px-3 py-2',
                    isDark ? 'bg-slate-800' : 'bg-slate-50',
                  )}
                >
                  <span className={cn('font-medium', isDark ? 'text-white' : 'text-[#111111]')}>
                    {payer.name}
                  </span>
                  {payer.is_company ? (
                    <span className={cn('text-xs', isDark ? 'text-slate-500' : 'text-slate-400')}>
                      счёт компании
                    </span>
                  ) : (
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => onDeletePayer(payer.id)}
                      className={cn(
                        'h-8 px-2 rounded-lg',
                        isDark ? 'text-slate-400 hover:bg-slate-700 hover:text-red-400' : 'text-slate-600 hover:bg-slate-100 hover:text-red-600',
                      )}
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
